import ErrorText from "app/components/form/error-text";
import { useFormikContext } from "formik";
import PropTypes from "prop-types";
import PhoneNumberInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

const PhoneField = ({ id, label, name, defaultCountry, onChange }) => {
  const { values, setFieldValue, handleBlur } = useFormikContext();

  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={id} className="text-sm font-semibold">
        {label}
      </label>
      <div lang="en">
        <PhoneNumberInput
          id={id}
          name={name}
          defaultCountry={defaultCountry}
          international={true}
          countryCallingCodeEditable={false}
          onBlur={handleBlur}
          onChange={(number) => {
            setFieldValue(name, number);
            onChange?.(number);
          }}
          value={values[name]}
        />
      </div>
      <ErrorText name={name} />
    </div>
  );
};

PhoneField.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  defaultCountry: PropTypes.string,
  onChange: PropTypes.func,
};

export default PhoneField;
